import StatisticsDescription from '../StatisticsDescription';

const StatisticsCard = ({ description, truncateAt, isExpanded, onToggle }) => {
  return (
    <StatisticsDescription
      description={description}
      truncateAt={truncateAt}
      isExpanded={isExpanded}
      onToggle={onToggle}
    />
  );
};

export default StatisticsCard;
